import React from 'react';
import { PageContentFooterTemplate } from 'themes/layouts';

function PageContentFooter(props) {
    return <PageContentFooterTemplate {...props} />;
}

export default PageContentFooter;
